export enum CountPeriodType {
    Undefined = -1,
    Day = 0,
    Week = 1,
    Month = 2,
    Year = 3
}